import axios, { AxiosInstance } from 'axios';
import keycloak from '../config/keycloak';



class HttpClient {
    private axiosInstance: AxiosInstance;

    constructor(baseUrl: string) {
        this.axiosInstance = axios.create({
            baseURL: baseUrl,
            headers: {
                "Content-Type": "application/json",
            },
        });

        this.axiosInstance.interceptors.request.use(
            async (config) => {
                const token = keycloak.token;
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );
    }

    getAxiosInstance(): AxiosInstance {
        return this.axiosInstance;
      }
}


export default HttpClient;